var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 26L15.8076 17.9562C15.0403 18.5701 14.1578 19.0561 13.1602 19.4142C12.1627 19.7723 11.1012 19.9514 9.97569 19.9514C7.18762 19.9514 4.82824 18.986 2.89756 17.0554C0.965852 15.1237 0 12.7638 0 9.97569C0 7.18762 0.965852 4.82772 2.89756 2.89602C4.82824 0.96534 7.18762 0 9.97569 0C12.7638 0 15.1237 0.96534 17.0554 2.89602C18.986 4.82772 19.9514 7.18762 19.9514 9.97569C19.9514 11.1012 19.7723 12.1627 19.4142 13.1602C19.0561 14.1578 18.5701 15.0403 17.9562 15.8076L26 23.9688L23.5625 26ZM9.97569 16.8819C11.8941 16.8819 13.525 16.2108 14.8684 14.8684C16.2108 13.525 16.8819 11.8941 16.8819 9.97569C16.8819 8.05729 16.2108 6.42639 14.8684 5.083C13.525 3.74063 11.8941 3.06944 9.97569 3.06944C8.05729 3.06944 6.42639 3.74063 5.083 5.083C3.74063 6.42639 3.06944 8.05729 3.06944 9.97569C3.06944 11.8941 3.74063 13.525 5.083 14.8684C6.42639 16.2108 8.05729 16.8819 9.97569 16.8819Z",
    fill: "#3D3D3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0c30e19e5cb188c70a3369ae1fc95e8e.svg";
export { ForwardRef as ReactComponent };